import { Flex, Box, Show } from "@chakra-ui/react";
import Image from "next/image";

import LandingContainer from "../LandingContainer";

import SectionTitle from "../SectionTitle";

const PARTNERS = [
  {
    key: "witness_chain",
    imgLink: "/assets/landingPage/partners/witness_chain.svg",
    name: "witness_chain",
  },
  {
    key: "mui",
    imgLink: "/assets/landingPage/partners/mui.svg",
    name: "mui",
  },
];

const Partners = () => {
  return (
    <LandingContainer>
      <Flex
        justifyContent="space-between"
        alignItems={{ base: "flex-start", md: "center" }}
        flexDir={{ base: "column", md: "row" }}
        gap="40px"
      >
        <SectionTitle w="412px" maxW="100%" title="Meet our partners" />

        <Flex gap="8px" flexDir={{ base: "column", md: "row" }}>
          {PARTNERS.map((data) => (
            <Box key={data.name}>
              <Show below="md">
                <Image
                  width={520}
                  height={220}
                  src={data.imgLink}
                  alt={data.name}
                />
              </Show>
              <Show above="md">
                <Image
                  width={346}
                  height={120}
                  src={data.imgLink}
                  alt={data.name}
                />
              </Show>
            </Box>
          ))}
        </Flex>
      </Flex>
    </LandingContainer>
  );
};

export default Partners;
